module.exports = __webpack_public_path__ + "static/media/22.c494267d.jpg";